'use strict';

angular.module('TurneroApp').component('coGrupos', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        '$state',
        'gruposService',
        'utilsService',
		  'TurneroAppConstant',
        function ($state, gruposService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.grupoCrear = false;
            ctrl.grupoModificar = false;
            ctrl.grupoConsultar = true;
            ctrl.grupoVer = false;
            ctrl.grupos = {};
            ctrl.focusBuscar = false;
            ctrl.permisos = TurneroAppConstant.Permisos;

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.filter = false;

            ctrl.$onChanges = function () {
                ctrl.centroAtencionSeleccionado.id && ctrl.grillaReload();
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.limpiarMemoria = function () {
                ctrl.grupos = {};
                ctrl.grupoCrear = false;
                ctrl.grupoModificar = false;
                ctrl.grupoConsultar = false;
                ctrl.grupoVer = false;
            }

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.grillaReload = function () {
                ctrl.limpiarMemoria();
                ctrl.grupoConsultar = true;
                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                }
            };

            ctrl.getData = function (page, limit, tipo, callback) {



                gruposService.getfiltro({
                    'filtro.id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id,
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter
                }).$promise.then(function (data) {
                    if (data.Data.length > 0) {
                        for (var i = 0 ; i < data.Data.length; i++) {
                            var arrayPuestos = data.Data[i].Lista_Puestos.split(',');
                            data.Data[i].N_Puesto_List = [];
                            for (var j = 0 ; j <= arrayPuestos.length; j++) {
                                data.Data[i].N_Puesto_List.push({ 'tipo': arrayPuestos[j] });
                            }
                        }
                    }
                    callback(tipo, data);
                }).catch(function (req) {
                    utilsService.errores(req);
                });

            }

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.grupos = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObjeto = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = [ctrl.centroAtencionSeleccionado.id, ctrl.centroAtencionSeleccionado.text];
                    ctrl.arrayExport[1] = ['Id', 'Nombre', 'Puestos'];
                    for (var i = 0; i < arrayObjeto.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObjeto[i].Id_Grupo,
                            arrayObjeto[i].N_Grupo,
                            arrayObjeto[i].Lista_Puestos
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Grupos',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            ctrl.crearGrupo = function () {
                ctrl.limpiarMemoria();
                ctrl.grupoCrear = true;
                ctrl.tLoadAlta();
            };

            ctrl.modificarGrupo = function (item) {
                ctrl.limpiarMemoria();
                ctrl.grupoModificar = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.verGrupo = function (item) {
                ctrl.limpiarMemoria();
                ctrl.grupoVer = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.eliminarGrupo = function (item) {
                swal({
                    title: "Eliminar Grupo",
                    text: "¿Desea quitar el grupo del centro de atención?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!",
                }).then(function () {
                    gruposService.delete({ 'id': item.Id_Grupo }).$promise.then(function (res) {
                        ctrl.grillaReload();
                        swal("Eliminado!", "El grupo ha sido eliminado del centro correctamente.", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });

                });
            };

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo, arrayObjeto) {
                ctrl.arrayExport = [];
                ctrl.getData(1, ctrl.pagination.total,tipo, cargarDatos)

            }
            ctrl.Excel = {
                down: function () {
                },
            }
        }
    ],
    template: require('./grupos.html')
});



// WEBPACK FOOTER //
// ./app/components/grupos/gruposComponent.js